import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please sign in.");
      nav("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-[#F8FAFC] p-6">
      <div className="w-full max-w-sm">
        <img src="/cass-logo-light.png" alt="CASS" className="h-12 w-auto object-contain mx-auto mb-8" />
        <h1 className="text-2xl font-extrabold text-[#0B1A2F] font-display">Set a new password</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Enter a new password for your CASS account.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="password">New password</Label>
            <Input id="password" data-testid="reset-password-input" type="password" required minLength={8}
              value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" />
          </div>
          {error && <p className="text-sm text-rose-600">{error}</p>}
          <Button type="submit" data-testid="reset-submit-btn" disabled={loading || !token}
            className="w-full bg-[#2EA3FD] hover:bg-[#1B8EE6] text-white font-semibold">
            {loading ? "Saving…" : "Reset password"}
          </Button>
        </form>
        <div className="text-center mt-4">
          <Link to="/login" className="text-sm text-[#2EA3FD] hover:underline">Back to sign in</Link>
        </div>
      </div>
    </div>
  );
}
